<template>
    <div>
        <el-row :gutter="15">
            <el-col :xs="24" :sm="24" :md="16">
                <el-form label-position="top">
                    
                    <el-row :gutter="10" class="u-mt-20">
                        <el-col :xs="12" :sm="24" :md="24">
                            <el-form-item label="Linhas do arquivo (uma por registro, 48 posições cada)">
                                <el-input type="textarea" :rows="15" v-model="conteudo" class="mono" placeholder="0010000000030051100200000015001/05/2011D000000S2" style="border-top: 1px solid rgb(152, 152, 152) !important; border-left: 1px solid rgb(152, 152, 152) !important; border-right: 1px solid rgb(152, 152, 152) !important;"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="18" :md="18">
                            <el-form-item label="Mês">
                                <el-select v-model="competencia.mes" style="width: 100%;">
                                    <el-option v-for="m in meses" :key="m.value" :label="m.label" :value="m.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="6" :md="6">
                            <el-form-item label="Ano">
                                <el-input-number v-model="competencia.ano" :min="2000" :max="2100" :controls="false"
                                    style="width: 100%;"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <div class="u-mb-15 u-text-right">
                    <el-button plain icon="el-icon-download" @click="carregarDaCompetencia" :loading="carregandoPrevia">
                        CARREGAR DA COMPETÊNCIA
                    </el-button>
                    <el-button type="primary" icon="el-icon-check" @click="validar" :loading="validando">VALIDAR</el-button>
                </div>
            </el-col>

            <el-col :xs="24" :sm="24" :md="8">
                <h4 class="u-mb-10">Layout de referência</h4>
                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr><th>Campo</th><th style="width: 50px;">De</th><th style="width: 50px;">Até</th><th style="width: 50px;">Tam.</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="(c, i) in layout" :key="i">
                                <td>{{ c.rotulo }}</td><td>{{ c.de }}</td><td>{{ c.ate }}</td><td>{{ c.tamanho }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-col>
        </el-row>

        <div v-if="resultado">
            <el-alert v-if="resultado.valido" type="success" :closable="false" class="u-mb-15"
                :title="`${resultado.total} linha(s) analisada(s) — nenhum problema encontrado.`"></el-alert>
            <el-alert v-else type="error" :closable="false" class="u-mb-15"
                :title="`${resultado.com_erro} de ${resultado.total} linha(s) com problema.`"></el-alert>

            <div v-for="l in resultado.linhas" :key="l.numero" class="linha-bloco">
                <div class="linha-cabecalho">
                    <span class="linha-numero" :class="l.valida ? 'ok' : 'erro'">
                        <i :class="l.valida ? 'el-icon-check' : 'el-icon-close'"></i> Linha {{ l.numero }}
                    </span>
                    <code class="linha-bruta">{{ l.linha }}</code>
                </div>

                <ul v-if="l.erros.length" class="linha-erros">
                    <li v-for="(e, i) in l.erros" :key="i">{{ e }}</li>
                </ul>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 90px;">Posições</th>
                                <th style="width: 190px;">Campo</th>
                                <th style="width: 130px;">Conteúdo</th>
                                <th>Interpretação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="c in l.campos" :key="c.chave" :class="{ 'campo-erro': c.erro }">
                                <td class="mono">{{ c.posicoes }}</td>
                                <td>{{ c.rotulo }}</td>
                                <td class="mono">{{ exibirBruto(c.bruto) }}</td>
                                <td>
                                    {{ c.interpretado }}
                                    <div v-if="c.erro" class="campo-msg">{{ c.erro }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Validador do layout de importação de eventuais. Decompõe cada linha nas 48
// posições do layout da Fiorilli e mostra o que o SIP leria em cada campo.
export default {
    name: 'AbaValidador',
    data: () => ({
        conteudo: '',
        layout: [],
        resultado: null,
        validando: false,
        carregandoPrevia: false,
        competencia: { mes: new Date().getMonth() + 1, ano: new Date().getFullYear() },
        meses: [
            { value: 1, label: 'Janeiro' }, { value: 2, label: 'Fevereiro' }, { value: 3, label: 'Março' },
            { value: 4, label: 'Abril' }, { value: 5, label: 'Maio' }, { value: 6, label: 'Junho' },
            { value: 7, label: 'Julho' }, { value: 8, label: 'Agosto' }, { value: 9, label: 'Setembro' },
            { value: 10, label: 'Outubro' }, { value: 11, label: 'Novembro' }, { value: 12, label: 'Dezembro' }
        ]
    }),
    mounted () {
        this.getLayout()
    },
    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },
        exibirBruto (bruto) {
            // espaços em branco precisam ficar visíveis no diagnóstico
            return (bruto === null || bruto === undefined) ? '' : String(bruto).replace(/ /g, '·')
        },
        getLayout () {
            this.$axios.get(`${this.baseUrl()}/configuracao/layout`, this.$store.getters.getHeaderAuth)
                .then(res => { this.layout = res.data || [] })
                .catch(e => this.$emit('erro', e))
        },
        validar () {
            if (!(this.conteudo || '').trim()) {
                window.eventBus.$emit('alert', { msg: 'Informe ao menos uma linha para validar.', type: 'warning' })
                return
            }

            this.validando = true

            this.$axios.post(`${this.baseUrl()}/configuracao/validar-linha`, { conteudo: this.conteudo }, this.$store.getters.getHeaderAuth)
                .then(res => { this.resultado = res.data; this.validando = false })
                .catch(e => { this.validando = false; this.$emit('erro', e) })
        },
        /** Traz as linhas que a competência geraria, para conferir sem baixar o arquivo. */
        carregarDaCompetencia () {
            this.carregandoPrevia = true

            this.$axios.post(`${this.baseUrl()}/exportacao/previa`, this.competencia, this.$store.getters.getHeaderAuth)
                .then(res => {
                    this.carregandoPrevia = false
                    const linhas = (res.data && res.data.linhas) || []

                    if (!linhas.length) {
                        window.eventBus.$emit('alert', { msg: 'Nenhum lançamento nesta competência.', type: 'warning' })
                        return
                    }

                    this.conteudo = linhas.slice(0, 50).join('\n')
                    this.validar()
                })
                .catch(e => { this.carregandoPrevia = false; this.$emit('erro', e) })
        }
    }
}
</script>

<style scoped>
.mono, .mono >>> textarea { font-family: monospace; }
.linha-bloco { margin-bottom: 22px; }
.linha-cabecalho { margin-bottom: 6px; }
.linha-numero { font-weight: 600; margin-right: 10px; }
.linha-numero.ok { color: #67c23a; }
.linha-numero.erro { color: #f56c6c; }
.linha-bruta { font-family: monospace; background: #f5f7fa; padding: 3px 8px; border-radius: 3px; font-size: 12px; }
.linha-erros { color: #f56c6c; font-size: 12px; margin: 6px 0 10px 18px; }
.campo-erro { background: #fef0f0 !important; }
.campo-msg { color: #f56c6c; font-size: 11px; margin-top: 2px; }
</style>
